import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenContext } from "../blank/blank-context";

declare let window: any;

export interface IYeniUrunler_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYeniUrunler_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetLanguage: string;
  SetLanguage_dummy: string;
  GetParametreler: any[];
  GetParametreler_dummy: any[];
  GetLanguage: string;
  GetLanguage_dummy: string;
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  GetCariBilgileri: any[];
  GetCariBilgileri_dummy: any[];
  GetToplamTeklifSepeti: any[];
  GetToplamTeklifSepeti_dummy: any[];
  GetToplamSiparisSepetUrunSayisi: any[];
  GetToplamSiparisSepetUrunSayisi_dummy: any[];
  GetYeniUrunler: any[];
  GetYeniUrunler_dummy: any[];
  GetCariParaBirimi: any[];
  GetCariParaBirimi_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  isComp68538Visible: "visible" | "hidden";
  isComp492825Visible: "visible" | "hidden";
  isComp997364Visible: "visible" | "hidden";
}

export class YeniUrunler_ScreenBase extends React.PureComponent<
  IYeniUrunler_ScreenProps,
  any
> {
  static contextType = Blank_ScreenContext;
  declare context: React.ContextType<typeof Blank_ScreenContext>;
  yeniurunler_389409_value_kuikaGalleryViewRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 638909,
          PropertyName: "placeholder",
          Value:
            "VADEN NUMBER, OEM NUMBER, PRODUCT NUMBER, PRODUCT NAME, BRAND, MODEL, VEHICLE",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 701483,
          PropertyName: "label",
          Value: "PROFILE",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 235246,
          PropertyName: "value",
          Value: "NEW PRODUCTS",
          TagName: "Label32_value",
        },
        {
          Id: 482869,
          PropertyName: "value",
          Value:
            "YOU CAN VIEW ALL NEWLY ADDED PRODUCTS HERE AND CREATE AN OFFER OR ORDER",
          TagName: "Label39_value",
        },
        {
          Id: 998141,
          PropertyName: "label",
          Value: "VIEW",
          TagName: "Button1_label",
        },
        {
          Id: 19712282,
          PropertyName: "b07c2b70-c18a-b993-a397-8d927e4577bd_notify",
          Value: "CANNOT ADD A PRODUCT WITHOUT A PRICE",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 638909,
          PropertyName: "placeholder",
          Value:
            "No. de vaden, No. oem, nombre de producto, marca, modelo, vehículo",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 701483,
          PropertyName: "label",
          Value: "Perfil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 235246,
          PropertyName: "value",
          Value: "Nuevos productos",
          TagName: "Label32_value",
        },
        {
          Id: 482869,
          PropertyName: "value",
          Value:
            "Ver todos los productos añadidos aquí y crear una cotización o pedido",
          TagName: "Label39_value",
        },
        {
          Id: 998141,
          PropertyName: "label",
          Value: "Revisar",
          TagName: "Button1_label",
        },
        {
          Id: 10456792,
          PropertyName: "b07c2b70-c18a-b993-a397-8d927e4577bd_notify",
          Value: "No se puede añadir al carrito un producto sin precio",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 638909,
          PropertyName: "placeholder",
          Value: "Vaden No , OEM No , Nom du produit, Marque, Modèle, Véhicule",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 701483,
          PropertyName: "label",
          Value: "Profil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 235246,
          PropertyName: "value",
          Value: "Nouveaux produits",
          TagName: "Label32_value",
        },
        {
          Id: 482869,
          PropertyName: "value",
          Value:
            "Vous pouvez consulter ici tous les nouveaux produits ajoutés et créer une offre ou une commande",
          TagName: "Label39_value",
        },
        {
          Id: 998141,
          PropertyName: "label",
          Value: "Consulter",
          TagName: "Button1_label",
        },
        {
          Id: 79555045,
          PropertyName: "b07c2b70-c18a-b993-a397-8d927e4577bd_notify",
          Value: "Vous ne pouvez pas ajouter au panier un produit sans prix",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "9dc3bda6-e662-4f91-af23-e7b6ae35936d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 638909,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        { Id: 420109, PropertyName: "label", Value: "Turkish" },
        { Id: 610730, PropertyName: "label", Value: "English" },
        { Id: 914901, PropertyName: "label", Value: "Spanish" },
        { Id: 124422, PropertyName: "label", Value: "French" },
        { Id: 701483, PropertyName: "label", Value: "Profil" },
        { Id: 235246, PropertyName: "value", Value: "Yeni Ürünler" },
        {
          Id: 482869,
          PropertyName: "value",
          Value:
            "Yeni Eklenen Ürünlerin Tamamını Burada Görüntüleyip Teklif Veya Sipariş Oluşturabilirsiniz",
        },
        {
          Id: 389409,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 443615, PropertyName: "value", Value: "[datafield:fiyat]" },
        {
          Id: 492825,
          PropertyName: "title",
          Value: "[datafield:adetbazlifiyataciklama]",
        },
        { Id: 884609, PropertyName: "value", Value: "[datafield:stok_kodu]" },
        {
          Id: 336763,
          PropertyName: "value",
          Value: "[datafield:birlesmisstok]",
        },
        { Id: 998141, PropertyName: "label", Value: "İncele" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.yeniurunler_638909_value_kuikaTextInputRef = React.createRef();
    this.yeniurunler_389409_value_kuikaGalleryViewRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      SetLanguage: "",
      GetParametreler: [],
      GetLanguage: "",
      GetKullanici: [],
      ReadFromSessionStorage: "",
      GetCariBilgileri: [],
      GetToplamTeklifSepeti: [],
      GetToplamSiparisSepetUrunSayisi: [],
      GetYeniUrunler: [],
      GetCariParaBirimi: [],
      IfThenElse: false,
      isComp68538Visible: "hidden",
      isComp492825Visible: "hidden",
      isComp997364Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("yeniurunler", "blank_screen");
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.YeniUrunlerPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.YeniUrunlerPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yeniurunler", "blank_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yeniurunler", "blank_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YeniUrunlerPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.YeniUrunlerPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YeniUrunlerPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YeniUrunler/YeniUrunlerPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetParametreler = result?.data.getParametreler;
    stateVars.isComp68538Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp997364Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YeniUrunlerPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YeniUrunlerPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GetLanguage = await ReactSystemFunctions.getLanguage(
      this.ml,
      this.defaultML
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YeniUrunlerPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YeniUrunlerPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YeniUrunler/YeniUrunlerPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.yeniurunler_977508_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YeniUrunlerPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YeniUrunlerPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YeniUrunlerPageInit4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YeniUrunlerPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      PlasiyerCariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      FirmaKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      tip_3: ReactSystemFunctions.convertToTypeByName(1, "number"),
      FiyatGrubu_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].fiyatgrubu
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].fiyatgrubu
            : null
        ),
        "string"
      ),
      CariKodu_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      ListeFiyati_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].listE_FIATI
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].listE_FIATI
            : null
        ),
        "string"
      ),
      dil_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      paraBirimi_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YeniUrunler/YeniUrunlerPageInit4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCariBilgileri = result?.data.getCariBilgileri;
    stateVars.GetToplamTeklifSepeti = result?.data.getToplamTeklifSepeti;
    formVars.yeniurunler_459306_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );
    stateVars.GetToplamSiparisSepetUrunSayisi =
      result?.data.getToplamSiparisSepetUrunSayisi;
    formVars.yeniurunler_902745_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );
    stateVars.GetYeniUrunler = result?.data.getYeniUrunler;

    stateVars.GetCariParaBirimi = result?.data.getCariParaBirimi;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YeniUrunlerPageInit5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YeniUrunlerPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.yeniurunler_459306_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );

    stateVars.isComp68538Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.yeniurunler_902745_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );

    formVars.yeniurunler_977508_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.yeniurunler_913930_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    stateVars.dataSource_389409 =
      stateVars.GetYeniUrunler ?? this.state.GetYeniUrunler;
    formVars.yeniurunler_909775_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp492825Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "yeniurunler_389409_value",
          "adetBazliFiyatVarMi"
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.isComp997364Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YeniUrunlerComponent_638909_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yeniurunler_638909_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YeniUrunler",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_68538_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/teklifolustur") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YeniUrunler",
      "TeklifOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_500921_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "FirmaKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YeniUrunler",
      "SiparisSepetOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "70678",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_420109_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("tr_TR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_610730_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("en_US", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_914901_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("es_ES", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_124422_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("fr_FR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_701483_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/profil") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YeniUrunler",
      "Profil",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_998141_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yeniurunler_389409_value",
          "stoK_KODU"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "listeFiat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].listE_FIATI
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].listE_FIATI
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "FiatGrup",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].fiyatgrubu
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].fiyatgrubu
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariParaBirimi !== undefined
            ? stateVars.GetCariParaBirimi?.length > 0
              ? stateVars.GetCariParaBirimi[0].paraSembol
              : null
            : this.state.GetCariParaBirimi?.length > 0
            ? this.state.GetCariParaBirimi[0].paraSembol
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "Kod3",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "yeniurunler_389409_value", "koD_3"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "MusteriMarka",
      ReactSystemFunctions.convertToTypeByName("VADEN", "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YeniUrunler",
      "prooductDetail",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "51459",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_997364_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "cariKod",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "BirimFiyat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "yeniurunler_389409_value", "fiyat"),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KulID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yeniurunler_389409_value",
          "stoK_KODU"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "PlasiyerMi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KdvOrani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yeniurunler_389409_value",
          "kdV_ORANI"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokAdi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yeniurunler_389409_value",
          "stoK_ADI"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isSiparis",
      ReactSystemFunctions.convertToTypeByName(false, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isYurtici",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "boolean"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YeniUrunler",
      "SepetModal",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "649738",
      null,
      null,
      "true",
      "400px",
      "38vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_576373_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "b07c2b70_c18a_b993_a397_8d927e4577bd_notify",
        this.defaultML,
        "Fiyatı olmayan ürünü sepete ekleyemezsiniz"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("#212121", "string"),
      ReactSystemFunctions.convertToTypeByName("#ffffff", "string"),
      14
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_576373_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "cariKod",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "BirimFiyat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "yeniurunler_389409_value", "fiyat"),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KulID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yeniurunler_389409_value",
          "stoK_KODU"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "PlasiyerMi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KdvOrani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yeniurunler_389409_value",
          "kdV_ORANI"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokAdi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yeniurunler_389409_value",
          "stoK_ADI"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isSiparis",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isYurtici",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "boolean"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YeniUrunler",
      "SepetModal",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "630317",
      null,
      null,
      "true",
      "400px",
      "38vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_576373_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "yeniurunler_389409_value", "fiyat"),
        "0"
      )
    ) {
      isErrorOccurred = await this.YeniUrunlerComponent_576373_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.YeniUrunlerComponent_576373_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YeniUrunlerComponent_336763_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [
      ,
      ,
      70678,
      ,
      51459,
      649738,
      630317,
    ] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YeniUrunlerPageInit();
    }
  }
}
